import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export default class DesignModelWizardData extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession()
  logo: string = '';

  @Observable()
  @StoreFieldInSession()
  font_display: string = '';

  @Observable()
  @StoreFieldInSession()
  font_main: string = '';

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(formData: {
    logo: string;
    font_display: string;
    font_main: string;
  }) {
    this.logo = formData.logo;
    this.font_display = formData.font_display;
    this.font_main = formData.font_main;
  }

  getWizardData() {
    return {
      logo: this.logo,
      font_map: {
        display: this.font_display,
        main: this.font_main
      }
    };
  }

  getSessionKey() {
    return 'DesignModelWizardData';
  }
}
